import axios, { AxiosResponse } from 'axios';
import ENV from '@/environment';

export type ContractLanguage = 'RU' | 'EN' | 'KZ';
export type UiLanguage = 'ru' | 'en' | 'kz' | string;

export type ContractType =
  | 'Main'
  | 'Pda'
  | 'PdaBasic'
  | 'Rent'
  | 'HandoverAct'
  | 'ReturnAct'
  | 'GuaranteeAgreement'
  | 'Lease'
  | 'UserAgreement'
  | 'PrivacyPolicy'
  | 'PersonalDataProcessing'
  | 'PersonalDataPolitics'
  | 'RightsAndConsequences'
  | 'MarketingAgreement';

export interface ContractListItem {
  title: string;
  url: string;
  iconUrl?: string;
}

export interface ContractListResponse {
  contracts: ContractListItem[];
}

const CONTRACT_API_HOST = ENV.APP_CONTRACT_API_HOST;
const DOMAIN_NAME_HEADER = 'Delitime';

export function mapUiLanguageToContractLanguage(
  language: UiLanguage,
): ContractLanguage {
  switch ((language || '').toLowerCase()) {
    case 'ru':
      return 'RU';
    case 'kz':
      return 'KZ';
    case 'en':
    default:
      return 'EN';
  }
}

function buildHeaders(language: ContractLanguage) {
  return {
    'Accept-Language': language,
    'Domain-Name': DOMAIN_NAME_HEADER,
  };
}

export async function getContractList(
  language: ContractLanguage,
): Promise<AxiosResponse<ContractListResponse>> {
  return await axios.get(`${CONTRACT_API_HOST}/v1/contract/list`, {
    headers: buildHeaders(language),
  });
}

export async function getContractPreview(
  contractType: ContractType,
  language: ContractLanguage,
  version?: number,
): Promise<AxiosResponse<Blob>> {
  return await axios.get(
    `${CONTRACT_API_HOST}/v1/contract/${contractType}/preview`,
    {
      headers: buildHeaders(language),
      params: version !== undefined ? { version } : undefined,
      responseType: 'blob',
    },
  );
}
